export const getDataFromCache = (key) => {
  const listDataJson = localStorage.getItem(key);
  return listDataJson ? JSON.parse(listDataJson) : null;
};

export const setDataInCache = (key, data) => {
  try {
    data && localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.warn(error)
  }
};
